import {Button, CheckIcon, ModalPopup} from '@kit';

import React from 'react';

import {FilterSchema} from './filter-params';
import {Filters} from './use-filters';

import formCss from '../form.module.css';

type Props<S extends FilterSchema> = {
	filters: Filters<S>;
	header: string;
	/** поля фильтра — пункты списка li */
	children: React.ReactNode;
};

export function FiltersPopup<S extends FilterSchema>({filters, header, children}: Props<S>) {
	return (
		<ModalPopup open={filters.open} onClose={filters.toggle} header={header} maxWidth={500}>
			<ul className={formCss.form}>{children}</ul>
			<ul className={formCss.buttons}>
				<li>
					<Button appearance="primary" onClick={filters.toggle} icon={<CheckIcon />}>
						Применить
					</Button>
				</li>
				<li>
					<Button appearance="subtle" onClick={filters.reset} disabled={!filters.isSet}>
						Сбросить
					</Button>
				</li>
			</ul>
		</ModalPopup>
	);
}
